import { CommonModule, formatDate, registerLocaleData } from '@angular/common';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';
import { IndicadorAlertaDesproporcionalServicoService } from '../../service/Indicador-alerta-desproporcional-servico.service';
import { interval, Subscription, take } from 'rxjs';
import { indicadorDTO } from '../../modal/dto/indicadorDTO'; // Importe sua classe aqui
import { breadcrumb } from '../../modal/breadcrumb';
import { CORES } from '../../modal/mock-cor';
import { VagasDisponiveisModel } from '../../modal/VagasDisponiveisModel';
import { boxInfo } from '../../modal/boxInfo';
import { cormodal } from '../../modal/cormodal';
import { orgao } from '../../modal/regional/orgao';
import { IndicadorOrgaoService } from '../../service/IndicadorOrgao.service';
import { posto } from '../../modal/regional/posto';

// Mapeia a estrutura da resposta do seu back-end, que já tem o tempoAtualizacao
export interface IndicadorEspecialResponse {
    indicadores: any[];
    tempoAtualizacao: number;
    nomeTipoTela: string;
    orgao: OrgaoCompleto;
    posto: PostoC;
}

export interface OrgaoCompleto {
    nome: string | null;
    icone: string | null;
    codigo: string | null;
    valor: any;
    cor: string | null;
    corFarol: string | null;
    etapa: any | null;
    proximaEtapa: any | null;
    orgao: orgao;
    servicos: any[];
    semCorrespondecia: boolean;
    ordenacaoOrientacao: any | null;
}

export interface PostoC {
    posto: posto;
}


@Component({
    selector: 'app-vagas-desproporcionais-servico',
    standalone: true,
    imports: [CommonModule, MatCardModule],
    templateUrl: './vagas-desproporcionais-servico.html',
    styleUrls: ['./vagas-desproporcionais-servico.scss']
})
export class VagasDesproporcionaisServicoComponent implements OnInit, OnDestroy {
    @Input() nomeServico: string = '';
    public listaIndDiasDetalhe: boxInfo[] = []; // Usando o seu modelo boxInfo
    public listabreadcrumb: any[] = [];
    public nomeTela = "";
    public idTela: number = 0;
    ccFila: string = "";
    ccPosto: string = "";

    dataOrg = [];
    public listaOrg: boxInfo[] = [];

    private refreshSubscription: Subscription | undefined;
    textInd: string | null = "";
    textPos: string | null = "";
    textOrg: string | null = "";
    @Input() ehAlerta: boolean = false;
    ccOrgao: any;
    nomeOrgao: string = "";
    login: string | null = '';

    constructor(
        private route: ActivatedRoute, private router: Router,
        private indicadorAlertaDesproporcionalServicoService: IndicadorAlertaDesproporcionalServicoService,
        private OrgaoIndicadorService: IndicadorOrgaoService
    ) {
        const breadcrumbString = window.localStorage.getItem('breadcrumb');
        if (breadcrumbString) {
            var bc = JSON.parse(breadcrumbString);
        }
        if (bc != undefined && bc.length != 0) {
            for (let index = 0; index < bc.length; index++) {
                const element = bc[index];
                this.listabreadcrumb.push(new breadcrumb(element.label, element.url));
            }
            this.listabreadcrumb.push(new breadcrumb("Vagas", ""));
            console.log(this.listabreadcrumb);
        }
        else {
            this.listabreadcrumb = [
                new breadcrumb("Alerta", "/indicador-alerta"),
                new breadcrumb("Posto", "/indicador-posto"),
                new breadcrumb("Orgão", "/indicador-orgao"),
                new breadcrumb("Serviços", "/indicador-fila"),
                new breadcrumb("Vagas", "")
            ];
        }
    }

    ngOnInit(): void {
        this.login = localStorage.getItem('login');
        this.route.queryParams.subscribe(params => {
            this.ehAlerta = params['ehAlerta'] === 'true';
            this.idTela = Number(params['tipoTela']) || 0;
            this.ccPosto = params['CcPosto'] || null;
            this.ccOrgao = params['CcOrgao'] || null;
            this.textInd = params['textInd'] || '';
            this.textPos = params['textPos'] || '';
            this.textOrg = params['textOrg'] || '';
            this.nomeServico = params['nomeServico'] || '';

            if (params['variaveis']) {
                try {
                    const variaveis = JSON.parse(params['variaveis']);
                    if (variaveis && variaveis.variaveis && variaveis.variaveis.length > 0) {
                        const ccFilaObj = variaveis.variaveis.find((v: any) => v.CcFila);
                        if (ccFilaObj) {
                            this.ccFila = ccFilaObj.CcFila;
                        }
                    }
                } catch (e) {
                    console.error('Erro ao fazer parse do JSON em "variaveis":', e);
                }
            }
            this.fetchData();
        });


    }

    navigateWithStateBC(link: string | null) {
        if (link != null) {
            const index = this.listabreadcrumb.findIndex(b => b.url === link);
            //console.log("LINK", Link);
            if (index !== -1) {
                this.listabreadcrumb = this.listabreadcrumb.slice(0, index);
            }
            window.localStorage.setItem('breadcrumb', JSON.stringify(this.listabreadcrumb));
        }

        // Cria um objeto para os parâmetros de consulta
        let params: any = {
            tipoTela: this.idTela,
            CcPosto: this.ccPosto,
            CcOrgao: this.ccOrgao,
            textInd: this.textInd,
            textPos: this.textPos
        };

        // Adiciona o ehAlerta se a variável for verdadeira
        if (this.ehAlerta === true) {
            params.ehAlerta = true;
        }

        this.router.navigate(['' + link], {
            queryParams: params
        });
    }

    extractMatches(valor: string): string {
        const regex = /\s\d+\/\d+/g;
        const matches = valor.match(regex);
        if (matches) {
            return " " + matches.join(' ').trim();
        }
        return "";
    }

    fetchData(): void {
        if (this.ccPosto && this.ccFila && this.idTela) {
            this.indicadorAlertaDesproporcionalServicoService
                .getindicadores(this.idTela, this.ccPosto, this.ccFila, this.ccOrgao, this.login == undefined ? "" : this.login)
                .pipe(take(1))
                .subscribe((response: IndicadorEspecialResponse[]) => {
                    this.listaIndDiasDetalhe = [];
                    if (response && response.length > 0) {
                        const especial = response[0];
                        const indicadoresAPI = especial.indicadores;
                        //this.nomeTela = especial.nomeTipoTela;


                            this.nomeTela =
                                especial.nomeTipoTela
                                + " ( do orgão " + especial.orgao.orgao.descricao
                                + " do posto " + especial.posto.posto.descricao + ")";
                        this.nomeOrgao = especial.orgao.orgao.descricao;
                        if (indicadoresAPI && indicadoresAPI.length > 0) {
                            this.listaIndDiasDetalhe = indicadoresAPI.map((indicadorAPI: any) => {
                                // Adiciona a verificação para garantir que indicadorAPI.valores não é null
                                const valores = indicadorAPI.valores || [];
                                const vagasDisponiveis = valores.find((x: any) => x.nome === "Vagas disponíveis");
                                const totalVagas = valores.find((x: any) => x.nome === "Total de vagas");

                                const corEncontrada = CORES.find(x => x.status === indicadorAPI.cor);

                                const corObjeto = corEncontrada ? new cormodal(corEncontrada.status, corEncontrada.fundoCor, corEncontrada.cabecalhoCor, corEncontrada.ordenacao) : new cormodal("Default", "#9e9e9e", "#818181", 2);

                                // Popula a nova instância de boxInfo com os dados do JSON
                                return new boxInfo(
                                    indicadorAPI.codigo.toString(),
                                    formatDate(indicadorAPI.nome, 'dd/MM E', 'pt-BR'),
                                    indicadorAPI.linkRedirect,
                                    corObjeto,
                                    `Disponíveis: ${vagasDisponiveis?.valorFormatado || 'N/A'}<br>Total: ${totalVagas?.valorFormatado || 'N/A'}`,
                                    undefined,
                                    "fa-solid fa-chart-column"
                                );
                            });
                        }

                        if (especial.tempoAtualizacao) {
                            this.setupAutoRefresh(especial.tempoAtualizacao);
                        }
                    }
                });
        }
    }

    setupAutoRefresh(tempoEmSegundos: number): void {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
        const tempoEmMs = tempoEmSegundos * 1000;
        this.refreshSubscription = interval(tempoEmMs).subscribe(() => {
            this.fetchData();
        });
    }

    ngOnDestroy(): void {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}
